import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
  .object({
    first_name: yup.string().required("First name is required"),
    last_name: yup.string().required("Last name is required"),
    phone_number: yup
      .string()
      .matches(/^[0-9]+$/, "Phone number must contain only digits")
      .test("num", "Invalid phone number format", (val) => !val.startsWith("0"))
      .min(9, "Invalid phone number format")
      .max(11, "Invalid phone number format")
      .required("Phone number is required"),
    email: yup
      .string()
      .email("Invalid email address")
      .max(50, "Maximum of 50 characters is allowed"),
    dob_day: yup
      .mixed()
      .test(
        "required",
        "Day of birth is required",
        (val) => val !== undefined && val !== null && val !== "",
      ),
    dob_month: yup
      .mixed()
      .test(
        "required",
        "Month of birth is required",
        (val) => val !== undefined && val !== null && val !== "",
      ),
    // customerCountry: yup.string(),
    // customerState: yup.string(),
  })
  .required("All fields are required");

export const useValidation = ({ ...formData }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...formData,
    },
  });
};
